<template>
  <div
    v-if="this.$route.path === '/agenda' && ListaAgendamentos.length > 0"
    class="floating"
    @click="openAgendamentosPDF(paciente.CodigoUnidade)"
  >
    <a class="helper-button">
      <i class="icon-ic_print" />
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'PrintButton',

  computed: {
    ...mapGetters({
      ListaAgendamentos: 'Agendamentos',
      isLoading: 'isLoading',
      agendamentosPdf: 'AgendamentosDocumento',
      paciente: 'dadosPaciente'
    })
  },
  methods: {
    ...mapActions(['getAgendamentosPDF']),
    onClick() {
      window.print()
    },
    async openAgendamentosPDF(unidade) {
      let newWin = window.open()
      await this.getAgendamentosPDF({ unidade }).then(() => {
        const file = new Blob([this.agendamentosPdf], {
          type: 'application/pdf'
        })
        const fileURL = URL.createObjectURL(file)
        newWin.location.href = fileURL
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/buttons';

.helper-button {
  display: flex;
  align-items: center;
  justify-content: center;

  .icon-ic_print {
    font-size: 1.5em;
  }
}
</style>
